import { render, staticRenderFns } from "./PersonSettings.vue?vue&type=template&id=04f57b66&scoped=true"
import script from "./PersonSettings.vue?vue&type=script&lang=js"
export * from "./PersonSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonSettings.vue?vue&type=style&index=0&id=04f57b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f57b66",
  null
  
)

export default component.exports